module.exports = __webpack_public_path__ + "static/media/snapshot.012badad.svg";